import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
    providedIn: 'root'
})

export class CareerService {
    private serverUrl = `${environment.apiUrl}/jobs`;

    constructor(private http: HttpClient) { }

    getData(page: number = 1, per_page: number): Observable<any> {
        return this.http.get<any>(`${this.serverUrl}?status=publish&page=${page}&per_page=${per_page}`);
    }

    getDetails(slug: string): Observable<any> {
        return this.http.get<any>(`${this.serverUrl}/${slug}`);
    }
    
    applyJob(formData: FormData): Observable<any> {
        return this.http.post<any>(`${this.serverUrl}/apply`, formData);
    }
}
